import React, { useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useEventListener } from 'react-recipes'
import { setFiltersThemesNumber, setFiltersYearNumber, setFiltersTypeNumber, setFiltersProfilesNumber, setFiltersHolderNumber } from '../store/actions'

const Accordion = ({prefixClass, type = 'text', titleLevel = 2, button, iconClosed, iconOpen, children, newsroomList = false, filterType = false}) => {
  // local state
  const [isOpen, setIsOpen] = useState(false)
  const [filtersCount, setFiltersCount] = useState(0)

  // refs
  const content = React.createRef()
  const contentInner = React.createRef()

  // newsroom filters update
  const filtersChange = useSelector(state => state.filtersChange)
  const dispatch = useDispatch()

  // toggle item on click
  const toggleItem = () => {
    if (!isOpen) {
      content.current.style.height = `${contentInner.current.offsetHeight}px`
    } else {
      content.current.style.height = '0px'
    }

    setIsOpen(!isOpen)
  }

  // handle resize: adapt height container to content height
  const handleResize = useCallback(() => {
    if (isOpen) {
      content.current.style.height = `${contentInner.current.offsetHeight}px`
    }
  }, [content, contentInner, isOpen])

  const handleFiltersCount = useCallback(() => {
    const count = contentInner.current.querySelectorAll('.ais-RefinementList-item--selected').length
    setFiltersCount(count)

    if (filterType === 'year') {
      dispatch(setFiltersYearNumber(count))
    } else if (filterType === 'themes') {
      dispatch(setFiltersThemesNumber(count))
    } else if (filterType === 'type') {
      dispatch(setFiltersTypeNumber(count))
    } else if( filterType === 'profile') {
      dispatch(setFiltersProfilesNumber(count))
    } else if (filterType === 'holder') {
      dispatch(setFiltersHolderNumber(count))
    }
    
  }, [contentInner, dispatch, filterType])

  // resize event listener
  useEventListener('resize', handleResize)

  useEffect(() => {
    if (newsroomList) {
      handleResize()
      handleFiltersCount()
    }
  }, [filtersChange, handleResize, handleFiltersCount, newsroomList])

  return (
    <div className={`${prefixClass} accordion ${isOpen ? 'is-open' : ''}`}>
      <button className={`${prefixClass}__toggle`} onClick={() => toggleItem()}>
        { type === 'title' 
          ? <>{ titleLevel === 2 ? <h2>{button}</h2> : <h3>{button}</h3>}</>
          : <p>{(newsroomList && filtersCount > 0 && !isOpen) && <span className={`${prefixClass}__count center`}>{filtersCount}</span>}{button}</p>
        }

        <svg className={`icon-night icon-closed flex-shrink-0 ${isOpen ? 'hidden' : 'block'}`} width="32" height="32">
          <use xlinkHref={iconClosed} />
        </svg>

        <svg className={`icon-night icon-open flex-shrink-0 ${isOpen ? 'block' : 'hidden'}`} width="32" height="32">
          <use xlinkHref={iconOpen} />
        </svg>
      </button>

      <div className="accordion__content" ref={content}>
        <div className={`${prefixClass}__content`} ref={contentInner}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default Accordion